import GSAP from 'gsap';
import each from 'lodash/each';
import Component from '@averyano/core/src/classes/Component';
// import Lightbox from '../../components/Lightbox';
export default class MarqComponent extends Component {
	constructor({ element, html }) {
		super({
			element: '.marq',
			elements: {
				wrapper: '.marq__wrapper',
				marqStack: '.marq__stack',
			},
		});

		this.isCreated = false;
		this.isMarqReady = false;
		this.marqHTML = html || '';
	}

	create = () => {
		console.log('Hello From MarqComponent');
		this.elements.wrapper = this.element.querySelector('.marq__wrapper');
		this.elements.marqStack = this.element.querySelector('.marq__stack');
		super.create();
	};

	createMarq() {
		this.x = 0;
		this.totalWidth = 0;
		console.log(this);
		if (!this.element || !this.elements.marqStack) return;

		const newMarqElement = document.createElement('div');
		newMarqElement.classList.add('marq__stack');
		newMarqElement.innerHTML = this.marqHTML;
		this.elements.marqStack = newMarqElement;
		this.elements.wrapper.innerHTML = '';
		this.elements.wrapper.appendChild(this.elements.marqStack);

		const marqWidth = this.elements.marqStack.offsetWidth;
		// calc how many marqStack items we need to fill the width of the screen
		const numItems = Math.ceil(window.innerWidth / marqWidth) + 2;

		console.log(numItems, marqWidth, window.innerWidth);

		if (marqWidth === 0 || numItems === 'Infinity') return;
		// this.elements.marq.innerHTML = '';

		if (numItems < 1) return (this.isMarqReady = true);
		const newMarqStack = this.elements.marqStack.outerHTML;
		for (let i = 0; i < numItems; i++) {
			this.elements.wrapper.insertAdjacentHTML('beforeend', newMarqStack);
		}

		const allMarqItems = this.element.querySelectorAll('.marq__stack');

		each(allMarqItems, (el) => {
			this.totalWidth += el.offsetWidth;
		});
		this.totalWidth = marqWidth * 2;

		// this.elements.marq.style.width = `${this.totalWidth}px`;
		this.elements.wrapper.style.transform = `translateX(${this.x}px)`;
		this.isMarqReady = true;
		this.frame = requestAnimationFrame(() => this.update());
	}

	addEventListeners() {
		this.element.addEventListener('mouseenter', () => {
			if (this.isMarqReady) {
				this.isMarqReady = false;
				window.cancelAnimationFrame(this.frame);
			}
		});
		this.element.addEventListener('mouseleave', () => {
			if (!this.isMarqReady) {
				this.isMarqReady = true;
				this.update();
			}
		});
	}

	onResize() {
		this.isMarqReady = false;
		window.cancelAnimationFrame(this.frame);
		this.createMarq();
	}

	show() {
		// this.create();
		// this.update();
	}

	update() {
		if (!this.isMarqReady) return;

		this.elements.wrapper.style.transform = `translateX(-${this.x}px)`;
		this.x += 0.33; // Adjust speed here

		if (this.x >= this.totalWidth - 1) {
			this.x = 0;
			this.elements.wrapper.style.transform = `translateX(${this.x}px)`;
		}

		this.frame = requestAnimationFrame(() => this.update());
	}

	destroy() {
		super.destroy();
	}
}
